import { render, staticRenderFns } from "./DamagedTotal.vue?vue&type=template&id=0ec2a53e&scoped=true&"
import script from "./DamagedTotal.vue?vue&type=script&lang=js&"
export * from "./DamagedTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec2a53e",
  null
  
)

export default component.exports